module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kHMTF"))).then(() => parcelRequire('1iHdE'));